import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';

export const displayCardTransformer = (data: CMSTransformerDataType) => ({
  themeColor: data.theme_color?.color?.color,
  themeShade: data.theme_color?.theme?.theme,
  backgroundColor: data.background_color,
  description: data.description,
  heading: data.heading,
  headingColor: data.heading_color,
  buttonBGColor: data.cta_background,
  image: data.image?.images,
  buttonText: data.link?.text,
  buttonTarget: data.link?.target,
  buttonURL: data.link?.url,
  descColor: data.descColor,
  borderColor: data.border_color,
});
const transformFeaturedDisplayCard = (data: CMSTransformerDataType) => ({
  componentType: ComponentType.featured_display_card,
  ...displayCardTransformer(data),
});

export default transformFeaturedDisplayCard;
